// El documento tributario de una nota en cualquier lista (2026-10-26: «en todos lados en vez de salirme
// el número de factura me tira la nota de venta»): «Factura N° 4978» como enlace a su ficha. El Shell
// entrega cómo abrir la ficha por contexto, así cada lista no tiene que recibirlo.
import { createContext, useContext, type ReactNode } from 'react';
import { tituloDte } from './pdfDte';

export interface DocumentoDeNota {
  documentoId: string;
  tipoDte: number;
  folio: string | null;
}

type AbrirDte = (documentoId: string, titulo: string) => void;
const Contexto = createContext<AbrirDte | null>(null);

export function ProveedorAbrirDte({ abrir, children }: { abrir: AbrirDte; children: ReactNode }) {
  return <Contexto.Provider value={abrir}>{children}</Contexto.Provider>;
}

export const useAbrirDte = () => useContext(Contexto);

/** Los documentos de la nota; sin documento, `vacio` (p. ej. «por emitir» o el tipo pedido). */
export function DocumentosNota({
  documentos,
  vacio = '—',
}: {
  documentos: readonly DocumentoDeNota[] | null | undefined;
  vacio?: ReactNode;
}) {
  const abrir = useAbrirDte();
  if (!documentos?.length) return <span className="apagado">{vacio}</span>;
  return (
    <span className="documentos-nota">
      {documentos.map((d, i) => {
        const t = tituloDte(d.tipoDte, d.folio);
        return (
          <span key={d.documentoId}>
            {i > 0 && ', '}
            {abrir ? (
              <button
                type="button"
                className="enlace"
                title="Abrir el documento"
                onClick={(e) => {
                  e.stopPropagation();
                  abrir(d.documentoId, t);
                }}
                onDoubleClick={(e) => e.stopPropagation()}
              >
                {t}
              </button>
            ) : (
              t
            )}
          </span>
        );
      })}
    </span>
  );
}
